import React from 'react'

const Startext = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="30" viewBox="0 0 26 26" width="30" xmlns="http://www.w3.org/2000/svg">
<path d="M14.625 21.125H21.125V22.75H14.625V21.125ZM14.625 17.875H24.375V19.5H14.625V17.875ZM14.625 14.625H24.375V16.25H14.625V14.625Z" fill="currentColor" fillOpacity="0.5"></path>
<path d="M16.696 9.11381L13 1.625L9.30392 9.11381L1.03998 10.3147L7.01998 16.1444L5.60785 24.375L11.375 21.3436V19.5073L7.76667 21.4045L8.62142 16.419L8.76604 15.5764L8.15423 14.9809L4.5321 11.4489L9.53792 10.7218L10.3829 10.5991L10.7615 9.83288L13 5.29669L15.2384 9.83288L15.617 10.5991L16.462 10.7218L22.5184 11.6033L22.75 9.99375L16.696 9.11381Z" fill="currentColor"></path>
</svg>
    )
}

export default Startext
